import { render, staticRenderFns } from "./RevolutPayCheckout.vue?vue&type=template&id=12037d60&scoped=true"
import script from "./RevolutPayCheckout.vue?vue&type=script&lang=js"
export * from "./RevolutPayCheckout.vue?vue&type=script&lang=js"
import style0 from "./RevolutPayCheckout.vue?vue&type=style&index=0&id=12037d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12037d60",
  null
  
)

export default component.exports